import React, { useContext, useEffect, useState } from 'react'
import { BsChevronRight } from 'react-icons/bs'
import { FaUser } from 'react-icons/fa'
import { IoMdArrowBack } from 'react-icons/io'
import { MdAddIcCall, MdHistory, MdNotificationsActive, MdNotificationsOff, MdOutlineCastForEducation, MdOutlineWorkOutline, MdPhoneAndroid } from 'react-icons/md'
import { useParams } from 'react-router'
import { Link } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import AddNewFollowup from '../../Components/Followup/AddNewFollowup'
import CandidateApplicationRecords from '../../Components/CreateApplications/CandidateApplicationRecords'
import ResumeBuildingHome from '../../Components/Jobs/ResumeBuilding/ResumeBuildingHome'
import ApplicationStatusSummary from '../../Components/ManageUser/InRecruitmentDomain/ApplicationStatusSummary'
import ImageUploader from '../../Components/ManageUser/InRecruitmentDomain/ImageUploader'
import UpdateCourseInterestLevel from '../../Components/ManageUser/InRecruitmentDomain/UpdateCourseInterestLevel'
import UpdateJobUrgencyLevel from '../../Components/ManageUser/InRecruitmentDomain/UpdateJobUrgencyLevel'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import styles from '../ManageUsers/UserProfileGrow.module.css'

const UserProfileGrow = () => {
    const authCtx = useContext(AuthContext)
    let params = useParams();
    const [selectedUser, setSelectedUser] = useState(null)
    // const selectedUser = { stylist_id : params.userId }

    const [courseInterestLevelOpen, setCourseInterestLevelOpen] = useState(false)
    const abortCourseInterestLevelMission = () => setCourseInterestLevelOpen(false)

    const [urgencyLevelOpen, setUrgencyLevelOpen] = useState(false)
    const abortUrgencyLevelMission = () => { setUrgencyLevelOpen(false) }

    const [selectedProfileType, setSelectedProfileType] = useState(null)
    const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(null);
    const [isLookingForJob, setIsLookingForJob] = useState(null);
    const [isSummary, setIsSummary] = useState(true)
    const [isUpdating, setIsUpdating] = useState(false)
    const [selectedApplicationStat, setSelectedApplicationStat] = useState('')
    const applicationStatTypeHandler = async (k) => {
        setSelectedApplicationStat(k)
        setSelectedProfileType(null)
        setIsSummary(false)
    }
    const [collectingWorkingStatus, setCollectingWorkingStatus] = useState(false)

    const [isUploadingPic, setIsUploadingPic] = useState(false)
    const toggleOpen = () => setIsUploadingPic(false)
    const [isCandidateAppRecOpen, setIsCandidateAppRecOpen] = useState(false)
    const [isAddNewFollowupOpen, setIsAddNewFollowupOpen] = useState(false)

    const optionsData = [
        {
            "icon": <FaUser />,
            "title": 'Personal Information',
            "key": '1'
        },
        {
            "icon": <FaUser />,
            "title": 'Education Qualifications',
            "key": '2'
        },
        {
            "icon": <FaUser />,
            "title": 'Skills',
            "key": '3'
        },
        {
            "icon": <FaUser />,
            "title": 'Certificates / Diplomas',
            "key": '4'
        },
        {
            "icon": <FaUser />,
            "title": 'Language Spoken',
            "key": '5'
        },
        {
            "icon": <FaUser />,
            "title": 'Preferences',
            "key": '6'
        },
        {
            "icon": <FaUser />,
            "title": 'Experiences',
            "key": '7'
        },
    ]

    const setSelectedProfileTypeHandler = async (k) => {
        setSelectedApplicationStat(null)
        setIsSummary(false)
        setSelectedProfileType(k)
    }

    const setLookingForJobHandler = async () => {
        setIsLookingForJob(!isLookingForJob)
    }
    const setCurrentWorkingHandler = async () => {
        setIsCurrentlyWorking(!isCurrentlyWorking)
    }

    const getStylistDetails = async () => {
        const getStylistDetailsResponse = await fetch(BASE_URL_API + "/getStylistDetails",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    stylist_id: params.userId
                })
            });

        if (!getStylistDetailsResponse.ok) {
            console.log("Something went wrong : Server Error");
        } else {
            const getStylistDetailsRespo = await getStylistDetailsResponse.json();
            if (getStylistDetailsRespo.status === 'success') {
                setSelectedUser(getStylistDetailsRespo.response)
            } else {
                if (getStylistDetailsRespo.message === 'token Expired, please login again!') {
                    authCtx.logout()
                } else {
                    setSelectedUser(null)
                }
            }
            console.log(getStylistDetailsRespo)
        }
    }

    useEffect(() => {
        getStylistDetails()
    }, [params.userId])

    const getWorkingStatus = async () => {
        setCollectingWorkingStatus(true)
        const getWorkingStatusResponse = await fetch(BASE_URL_API + "/getWorkingStatus",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    stylist_id: selectedUser.stylist_id
                })
            });

        if (!getWorkingStatusResponse.ok) {
            console.log("Something went wrong : Server Error!");
        } else {
            const getWorkingStatusRespo = await getWorkingStatusResponse.json();
            if (getWorkingStatusRespo.status === "success") {
                console.log(getWorkingStatusRespo);
                setIsLookingForJob(getWorkingStatusRespo?.isLookingForJob)
                setIsCurrentlyWorking(getWorkingStatusRespo?.isCurrentlyWorking)
            } else {
                if (getWorkingStatusRespo.message === 'token Expired, please login again!') {
                    authCtx.logout();

                } else {
                    console.log(getWorkingStatusRespo);
                }
            }
        }
        setCollectingWorkingStatus(false)
    }

    useEffect(() => {
        if (selectedUser !== null) {
            getWorkingStatus()
        }
    }, [selectedUser])



    const toggleWorkingStatus = async (fieldType, fieldValue) => {
        // console.log(fieldType, fieldValue)
        setIsUpdating(true);
        const toggleWorkingStatusResponse = await fetch(BASE_URL_API + "/toggleWorkingStatus",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    stylist_id: selectedUser.stylist_id,
                    fieldType: fieldType,
                    fieldValue: fieldValue
                })
            });

        if (!toggleWorkingStatusResponse.ok) {
            console.log("Something went wrong : Server Error");
        } else {
            const toggleWorkingStatusRespo = await toggleWorkingStatusResponse.json();
            if (toggleWorkingStatusRespo.status === "success") {
                console.log(toggleWorkingStatusRespo)
                getWorkingStatus()
            } else {
                if (toggleWorkingStatusRespo.message === 'token Expired, please login again!') {
                    authCtx.logout();
                } else {
                    console.log(toggleWorkingStatusRespo);
                }
            }
            setIsUpdating(false);
        }
    }

    const onImgUploadSuccess = () => {
        getStylistDetails()
        toast("Image uploaded successfully!")
    }

    const formatTimeAgo = (dateStr) => {
        const date = new Date(dateStr.replace(' ', 'T'))
        const diffMs = Date.now() - date
        const diffMins = Math.floor(diffMs / 60000)
        const diffHours = Math.floor(diffMins / 60)
        const diffDays = Math.floor(diffHours / 24)
        if (diffMins < 1) return 'just now'
        if (diffMins < 60) return `${diffMins}m ago`
        if (diffHours < 24) return `${diffHours}h ago`
        return diffDays < 7 ? `${diffDays}d ago` : dateStr.split(' ')[0]
    }

    const hasDownloadedApp = selectedUser && ((selectedUser.appActivity?.length > 0) || (selectedUser.fcmTokenActivity?.length > 0))
    const hasNotificationsEnabled = selectedUser?.fcmTokenActivity?.some(t => t.is_active === "1")
    const lastActivity = selectedUser?.appActivity?.[0]
    const activeToken = selectedUser?.fcmTokenActivity?.find(t => t.is_active === "1")

    console.log("isCurrentlyWorking : " + isCurrentlyWorking, "isLookingForJob : " + isLookingForJob)

    return (
        <div className={styles.mainContainer}>
            <div className={styles.leftContainer}>
                {selectedUser !== null &&
                    <div className={styles.userBoxWrapper}>
                        <div className={styles.upperSectionWrapper}>
                            <div className={styles.backNavHeader}>
                                <div className={styles.backNavTitle}>Manage User Account</div>
                            </div>
                            <div className={styles.selectedUserWrapper}>
                                <div className={styles.userIconWrapper}
                                    onClick={() => setIsUploadingPic(true)}
                                >
                                    {selectedUser.stylist_profile_image !== '' ?
                                        <img src={selectedUser.stylist_profile_image} />
                                        :
                                        <FaUser size={26} />
                                    }
                                </div>
                                <div className={styles.selectedUserDetails}>
                                    <div className={styles.stylistName}>
                                        {selectedUser.stylist_name}
                                    </div>
                                    <div className={styles.stylistUsername}>
                                        {selectedUser.stylist_username}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }



                {selectedUser !== null &&
                    <div className={styles.leftMenuWrapper}>
                        {/* <ApplicationStatusSummary
                            selectedUser={selectedUser}
                            applicationStatTypeHandler={applicationStatTypeHandler}
                        /> */}

                        <div className={styles.updateLevelWrapper}>
                            <div className={styles.courseInterestLevel}
                                onClick={() => setCourseInterestLevelOpen(true)}
                                title="Update Course Interest Level"
                            >
                                <MdOutlineCastForEducation size={20} />
                            </div>
                            <div onClick={() => setUrgencyLevelOpen(true)}
                                className={styles.jobUrgencyLevel}
                                title="Update Job Urgency Level"
                            >
                                <MdOutlineWorkOutline size={20} />
                            </div>
                            <div onClick={() => setIsCandidateAppRecOpen(true)}
                                className={styles.jobUrgencyLevel}
                                title="Get Application History"
                            >
                                <MdHistory size={20} />
                            </div>
                            <div onClick={() => setIsAddNewFollowupOpen(true)}
                                className={styles.jobUrgencyLevel}
                                title="Add New Follow-up"
                            >
                                <MdAddIcCall size={20} />
                            </div>
                            <UpdateJobUrgencyLevel
                                isOpen={urgencyLevelOpen}
                                abortUrgencyLevelMission={abortUrgencyLevelMission}
                                stylistIdentifier={params.userId}
                            />
                            <UpdateCourseInterestLevel
                                isOpen={courseInterestLevelOpen}
                                abortCourseInterestLevelMission={abortCourseInterestLevelMission}
                                stylistIdentifier={params.userId}
                            />
                            <CandidateApplicationRecords
                                isOpen={isCandidateAppRecOpen}
                                onClose={() => setIsCandidateAppRecOpen(false)}
                                stylistIdentifier={params.userId}
                            />
                            {isAddNewFollowupOpen && <AddNewFollowup
                                isOpen={isAddNewFollowupOpen}
                                onClose={() => setIsAddNewFollowupOpen(false)}
                                onAdd={() => setIsAddNewFollowupOpen(false)}
                                stylist_identifier={params.userId}
                                stylistData={selectedUser}
                            />}
                        </div>


                        <div className={styles.optionsWrapper}>
                            {optionsData.map((item, index) => (
                                <div className={styles.eachOptionWrapper} key={index}
                                    onClick={() => setSelectedProfileTypeHandler(item.title)}
                                >
                                    <div className={styles.optionLeftWrapper}>
                                        <div className={styles.optionIcon}>
                                            {item.icon}
                                        </div>
                                        <div className={styles.optionTxt}>
                                            {item.title}
                                        </div>
                                    </div>
                                    <div>
                                        <BsChevronRight />
                                    </div>
                                </div>
                            ))}

                        </div>

                        {isUpdating === false &&
                            <div className={styles.actionBtnWrapper}>
                                <div className={styles.actionBtnContainer}>
                                    <div className={styles.actionBtnCaption}>
                                        Actively looking for job?
                                    </div>
                                    {collectingWorkingStatus !== true &&
                                        <div>
                                            <button className={isLookingForJob === '1' ? styles.activeBtn : styles.defaultBtn} onClick={() => toggleWorkingStatus('isLookingForJob', '1')}>Yes</button>
                                            <button className={isLookingForJob === '0' ? styles.activeBtn : styles.defaultBtn} onClick={() => toggleWorkingStatus('isLookingForJob', '0')}>No</button>
                                        </div>
                                    }
                                </div>
                                <div className={styles.actionBtnContainer}>
                                    <div className={styles.actionBtnCaption}>
                                        Currently Working?
                                    </div>
                                    {collectingWorkingStatus !== true &&
                                        <div>
                                            <button className={isCurrentlyWorking === '1' ? styles.activeBtn : styles.defaultBtn} onClick={() => toggleWorkingStatus('isCurrentlyWorking', '1')}>Yes</button>
                                            <button className={isCurrentlyWorking === '0' ? styles.activeBtn : styles.defaultBtn} onClick={() => toggleWorkingStatus('isCurrentlyWorking', '0')}>No</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        }

                        <div className={styles.findJobsWrapper}>
                            <Link to={"/jobs-finder/" + params?.userId}>Find Jobs For Candidate</Link>
                        </div>
                    </div>
                }
            </div>

            <div className={styles.rightContainer}>
                {selectedProfileType === null ?
                    <>
                        <div className={styles.activateResume}>
                            <Link to={`/manage-subscriptions/resume/${params?.userId}`}>Activate Resume</Link>
                            <Link to={`/manage-users/grow/${params?.userId}/content`}>Go To Content Manager</Link>
                        </div>
                        {selectedUser !== null && (
                            <div className={styles.appActivityWrapper}>
                                <div className={styles.appStatusRow}>
                                    <div className={`${styles.appStatusBadge} ${hasDownloadedApp ? styles.statusOn : styles.statusOff}`}>
                                        <MdPhoneAndroid size={18} />
                                        <div className={styles.badgeContent}>
                                            <span className={styles.badgeTitle}>{hasDownloadedApp ? 'App Downloaded' : 'App Not Downloaded'}</span>
                                            {hasDownloadedApp && lastActivity && (
                                                <span className={styles.badgeSub}>
                                                    {lastActivity.device_platform} &bull; last seen {formatTimeAgo(lastActivity.created_at)}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`${styles.appStatusBadge} ${hasNotificationsEnabled ? styles.statusOn : styles.statusOff}`}>
                                        {hasNotificationsEnabled ? <MdNotificationsActive size={18} /> : <MdNotificationsOff size={18} />}
                                        <div className={styles.badgeContent}>
                                            <span className={styles.badgeTitle}>{hasNotificationsEnabled ? 'Notifications Enabled' : 'Notifications Not Enabled'}</span>
                                            {hasNotificationsEnabled && activeToken && (
                                                <span className={styles.badgeSub}>v{activeToken.app_version} &bull; {activeToken.platform}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {authCtx.userIdentifier === "999964N8406" && (
                                    <div className={styles.adminDetailWrapper}>
                                        {selectedUser.fcmTokenActivity?.length > 0 && (
                                            <div className={styles.activitySection}>
                                                <div className={styles.activitySectionTitle}>FCM Token History</div>
                                                <div className={styles.fcmTokenList}>
                                                    {selectedUser.fcmTokenActivity.map((token, idx) => (
                                                        <div key={idx} className={`${styles.fcmTokenItem} ${token.is_active === "1" ? styles.tokenActive : styles.tokenInactive}`}>
                                                            <div className={styles.tokenDot} />
                                                            <div className={styles.tokenDetails}>
                                                                <div className={styles.tokenTopRow}>
                                                                    <span className={styles.tokenVersion}>v{token.app_version}</span>
                                                                    <span className={styles.tokenPlatform}>{token.platform}</span>
                                                                    <span className={`${styles.tokenStatusBadge} ${token.is_active === "1" ? styles.tokenStatusActive : styles.tokenStatusInactive}`}>
                                                                        {token.is_active === "1" ? "Active" : "Inactive"}
                                                                    </span>
                                                                </div>
                                                                <div className={styles.tokenDates}>
                                                                    <span>Registered {formatTimeAgo(token.created_at)}</span>
                                                                    <span>&bull;</span>
                                                                    <span>Updated {formatTimeAgo(token.updated_at)}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {selectedUser.appActivity?.length > 0 && (
                                            <div className={styles.activitySection}>
                                                <div className={styles.activitySectionTitle}>Recent App Activity</div>
                                                <div className={styles.appActivityList}>
                                                    {selectedUser.appActivity.map((item, idx) => (
                                                        <div key={idx} className={styles.appActivityItem}>
                                                            <div className={styles.activityEndpoint}>{item.endpoint.replace(/^\//, '')}</div>
                                                            <div className={styles.activityMeta}>
                                                                <span className={styles.activityPlatform}>{item.device_platform}</span>
                                                                <span className={styles.activityLang}>{item.selected_language}</span>
                                                                <span className={styles.activityTime}>{formatTimeAgo(item.created_at)}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                    :
                    <ResumeBuildingHome
                        selectedUser={selectedUser}
                        selectedProfileType={selectedProfileType}
                    />
                }
                {isUploadingPic &&
                    <ImageUploader
                        isOpen={isUploadingPic}
                        toggleOpen={toggleOpen}
                        stylistIdentifier={params?.userId}
                        onSuccess={onImgUploadSuccess}
                    />
                }
            </div>
        </div>
    )
}

export default UserProfileGrow